<div *ngIf="isLoading" class="loader"><div class="lds-rolling"><div></div></div></div>
